/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AdminCaseListBlock } from './AdminCaseListBlock';
import type { AdminCaseListSlide } from './AdminCaseListSlide';
import type { AdminCaseListSpecimen } from './AdminCaseListSpecimen';
import type { CaseQAReview } from './CaseQAReview';
import type { CaseReportSignature } from './CaseReportSignature';
import type { CaseStatusLog } from './CaseStatusLog';
import type { CliaCertificate } from './CliaCertificate';
import type { PatientFullInsurance } from './PatientFullInsurance';
import type { UserContact } from './UserContact';
import type { UserCredentials } from './UserCredentials';

export type AdminCaseList = {
    readonly id?: number;
    /**
     * WPL's accession value
     */
    accession?: string | null;
    patient: PatientFullInsurance;
    readonly ordering_doctor?: UserContact;
    readonly active_assignment?: UserCredentials;
    finalizing_signature: CaseReportSignature;
    /**
     * Changing this value will NOT modify the received_date for each specimen.
     */
    received_date?: string | null;
    readonly received_date_offset?: string;
    readonly received_date_timezone?: string;
    slides: Array<AdminCaseListSlide>;
    specimens: Array<AdminCaseListSpecimen>;
    blocks: Array<AdminCaseListBlock>;
    /**
     * current workflow status of the case
     */
    status?: AdminCaseList.status;
    status_log: Array<CaseStatusLog>;
    readonly grossed_by_cert?: CliaCertificate;
    working_reasons: any;
    priority?: AdminCaseList.priority;
    is_manually_accessioned?: boolean | null;
    is_screening?: boolean;
    /**
     * case origin, WPL or PW LIS
     */
    source?: AdminCaseList.source;
    qa_reviews: Array<CaseQAReview>;
}

export namespace AdminCaseList {

    /**
     * current workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
    }


}
